var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base container-fluid" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._m(0),
        _c(
          "button",
          { attrs: { type: "button" }, on: { click: _vm.reloadInvestments } },
          [_vm._v("Recarregar")]
        )
      ]),
      _vm.viewItem
        ? _c("ItemDetails", {
            attrs: { source: _vm.target },
            on: {
              close: function($event) {
                _vm.viewItem = false
              },
              reload: function($event) {
                _vm.reloadInvestments() && (_vm.viewItem = false)
              }
            }
          })
        : _vm._e(),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-center align-center pa-8" },
            [
              _c("v-progress-circular", {
                attrs: { size: 35, color: "primary", indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", [_vm._v(" ")]),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._l(_vm.items, function(item) {
            return _c("div", { key: item.id, staticClass: "block" }, [
              _c(
                "div",
                {
                  staticClass: "item-row item-info-row",
                  on: {
                    click: function($event) {
                      return _vm.toggleVisible(item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "item-full" }, [
                    _vm._v("Importação")
                  ]),
                  _c("div", { staticClass: "item-28" }, [
                    _vm._v(
                      "Importação: " + _vm._s(_vm.formatDate(item.createdAt))
                    )
                  ]),
                  _c("div", { staticClass: "item-28" }, [
                    _vm._v(
                      "Atualizado: " + _vm._s(_vm.formatDate(item.updatedAt))
                    )
                  ]),
                  _c("div", { staticClass: "item-28" }, [
                    _vm._v(
                      " De: " +
                        _vm._s(
                          (item && item.connector && item.connector.name) ||
                            "???"
                        ) +
                        " "
                    )
                  ]),
                  _c("div", { staticClass: "item-row item-15" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn-update",
                        attrs: {
                          title:
                            "Adicionar os investimentos desta importação para o Kristal"
                        },
                        on: {
                          click: function($event) {
                            return _vm.importItem($event, item)
                          }
                        }
                      },
                      [_vm._v(" Adicionar ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn-remote",
                        attrs: {
                          title:
                            "Atualizar os dados importados com informações mais recentes"
                        },
                        on: {
                          click: function($event) {
                            return _vm.updateItem($event, item)
                          }
                        }
                      },
                      [_vm._v(" Atualizar ")]
                    )
                  ])
                ]
              ),
              item.visible && item.investments && item.investments.length
                ? _c(
                    "div",
                    { staticClass: "block" },
                    _vm._l(item.investments, function(investment) {
                      return _c(
                        "div",
                        {
                          key: investment.investmentId,
                          staticClass: "children"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "item-row investment-info-row",
                              on: {
                                click: function($event) {
                                  return _vm.toggleVisible(investment)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "item-full" }, [
                                _vm._v(" " + _vm._s(investment.name) + " "),
                                investment.transactions &&
                                investment.transactions.length
                                  ? _c(
                                      "button",
                                      {
                                        attrs: {
                                          type: "button",
                                          title:
                                            "Selectionar todas as transações para adição ao Kristal."
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectAllTransactions(
                                              $event,
                                              investment
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getSelectAllLabel(investment)
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                investment.transactions &&
                                !investment.transactions.length
                                  ? _c(
                                      "button",
                                      {
                                        class: _vm.getInvestmentClass(
                                          investment
                                        ),
                                        attrs: {
                                          type: "button",
                                          title:
                                            "Selecionar investimento para adição ao Kristal"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleInvestmentStatus(
                                              $event,
                                              investment
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getSelectInvestmentLabel(
                                                investment
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _c("div", { staticClass: "item-33" }, [
                                _vm._v(
                                  "Status: " + _vm._s(investment.status_imp)
                                )
                              ]),
                              _c("div", { staticClass: "item-33" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.optionMessage(
                                      investment.message_imp,
                                      "Mensagem:"
                                    )
                                  ) +
                                    " " +
                                    _vm._s(investment.message_imp)
                                )
                              ]),
                              _c("div", { staticClass: "item-33" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.optionMessage(
                                      investment.date_imp,
                                      "Data:"
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.formatDate(investment.date_imp))
                                )
                              ]),
                              investment.visible
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item-33 hlt",
                                      attrs: {
                                        title: "Clique para editar o código"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.editCode(
                                            $event,
                                            investment
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Código: " + _vm._s(investment.code)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v("Isin: " + _vm._s(investment.isin))
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v("No.: " + _vm._s(investment.number))
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Propr.: " + _vm._s(investment.owner)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Moeda: " +
                                        _vm._s(investment.currencyCode)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v("Tipo: " + _vm._s(investment.type))
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Subt.: " + _vm._s(investment.subtype)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "T. últ. mês: " +
                                        _vm._s(
                                          _vm.percentageHelper.formatStandard(
                                            investment.lastMonthRate
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "T. anual: " +
                                        _vm._s(
                                          _vm.percentageHelper.formatStandard(
                                            investment.annualRate
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Data: " +
                                        _vm._s(_vm.formatDate(investment.date))
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Valor: " +
                                        _vm._s(
                                          _vm.currencyHelper.formatValue(
                                            investment.value
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Quantidade: " +
                                        _vm._s(investment.quantity)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Total: " + _vm._s(investment.amount)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v("Taxas: " + _vm._s(investment.taxes))
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Tx. adic.: " + _vm._s(investment.taxes2)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Saldo: " +
                                        _vm._s(
                                          _vm.currencyHelper.formatValue(
                                            investment.balance
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Venc.: " +
                                        _vm._s(
                                          _vm.formatDate(investment.dueDate)
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Taxa: " +
                                        _vm._s(
                                          _vm.percentageHelper.formatStandard(
                                            investment.rate
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Tp. Taxa: " + _vm._s(investment.rateType)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "T. fix. anual: " +
                                        _vm._s(
                                          _vm.percentageHelper.formatStandard(
                                            investment.fixedAnnualRate
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Emissor: " + _vm._s(investment.issuer)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Emissão: " +
                                        _vm._s(
                                          _vm.formatDate(investment.issueDate)
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Lucro: " +
                                        _vm._s(investment.amountProfit)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Saque: " +
                                        _vm._s(
                                          _vm.currencyHelper.formatValue(
                                            investment.amountWithdrawal
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Original: " +
                                        _vm._s(investment.amountOriginal)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Status: " + _vm._s(investment.status)
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "Nome b.: " +
                                        _vm._s(
                                          investment.institution &&
                                            investment.institution.name
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              investment.visible
                                ? _c("div", { staticClass: "item-33" }, [
                                    _vm._v(
                                      "No. b.: " +
                                        _vm._s(
                                          investment.institution &&
                                            investment.institution.number
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          investment.visible &&
                          investment.transactions &&
                          investment.transactions.length
                            ? _c(
                                "div",
                                { staticClass: "block" },
                                [
                                  _vm._m(1, true),
                                  _vm._l(investment.transactions, function(
                                    transaction
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: transaction.transactionId,
                                        staticClass:
                                          "item-row transaction-info-row"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item-full" },
                                          [
                                            _vm._v(" Transação "),
                                            _c("label", [
                                              _vm._v(
                                                " Selecionada para adição ao Kristal: "
                                              ),
                                              _c("input", {
                                                attrs: {
                                                  type: "checkbox",
                                                  title:
                                                    "Status de seleção para adição ao Kristal"
                                                },
                                                domProps: {
                                                  checked: _vm.getSelectTransStatus(
                                                    transaction
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleTransactionStatus(
                                                      $event,
                                                      transaction
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          ]
                                        ),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "Neg.: " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  transaction.tradeDate
                                                )
                                              )
                                          )
                                        ]),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "Data: " +
                                              _vm._s(
                                                _vm.formatDate(transaction.date)
                                              )
                                          )
                                        ]),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "Quant.: " +
                                              _vm._s(transaction.quantity)
                                          )
                                        ]),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "Valor: " +
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  transaction.value
                                                )
                                              )
                                          )
                                        ]),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "Total: " +
                                              _vm._s(transaction.amount)
                                          )
                                        ]),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "Tipo: " + _vm._s(transaction.type)
                                          )
                                        ]),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "Descr.: " +
                                              _vm._s(transaction.description)
                                          )
                                        ]),
                                        _c("div", { staticClass: "item-33" }, [
                                          _vm._v(
                                            "N. corr.: " +
                                              _vm._s(
                                                transaction.brokerageNumber
                                              )
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          investment.visible &&
                          !(
                            investment.transactions &&
                            investment.transactions.length
                          )
                            ? _c("div", { staticClass: "block empty" }, [
                                _vm._v(" Nenhuma transação encontrada ")
                              ])
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              false && !(item.investments && item.investments.length)
                ? _c("div", { staticClass: "item-row empty" }, [
                    _vm._v(" Nenhum investimento encontrado. ")
                  ])
                : _vm._e()
            ])
          }),
          !(_vm.items && _vm.items.length)
            ? _c("div", { staticClass: "block empty" }, [
                _vm._v(" Nenhuma importação encontrada. ")
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("span", { staticStyle: { color: "#b5e546" } }, [
        _vm._v("Investimento(s)")
      ]),
      _vm._v(" importados")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-row transaction-info-row" }, [
      _c("div", { staticClass: "item-full" }, [_vm._v("Transações")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }